import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./CMSDropdown.module.css";
import CMSSectionElement from "../CMSSectionElement";
import classNames from "classnames";
import Button from "../Button";
import SearchBar from "../SearchBar";
import CMSSearchItem from "../CMSSearchItem";
import { useContentsGet } from "./useContentsGet";
import { useSingleContentsGet } from "./useSingleContentsGet";
import Loader from "shared/Loader";

/**
 * View component. Displays CMS item content for a feed item section.
 */
export function CMSDropdown({ cmsItem, setCmsItem }) {
  const {
    data: allCmsItems,
    refetch: refetchAll,
    isLoading: isLoadingAll,
  } = useContentsGet();

  const {
    data: singleCmsItem,
    refetch: refetchSingle,
    isLoading: isLoadingSingle,
  } = useSingleContentsGet({ id: cmsItem.contentId });

  const [hidden, setHidden] = useState(false);
  const [light, setLight] = useState(false);

  const [selectedCMSItem, setSelectedCMSItem] = useState(singleCmsItem);

  useEffect(() => {
    if (singleCmsItem) {
      setSelectedCMSItem(singleCmsItem);
    }
  }, [singleCmsItem]);

  const [cmsItemsToShow, setCmsItemsToShow] = useState([]);

  const cmsItemSearch = (value) => {
    if (value.trim() === "") {
      // If the value is empty, clear search results
      setCmsItemsToShow([]);
      return; // Exit the function
    }

    // Filter items based on the contentId
    const searchResults = allCmsItems.filter((item) => {
      return (
        item.contentId.toString().includes(value.toString()) ||
        item.title.toLowerCase().includes(value.toLowerCase())
      );
    });

    // Update state with the search results
    setCmsItemsToShow(searchResults);
  };

  const addCmsItem = (item) => {
    setSelectedCMSItem(item);
    setCmsItem(item);
  };

  if (isLoadingAll || isLoadingSingle || !selectedCMSItem) {
    return <Loader />;
  }

  return (
    <div className={classNames(styles.none, styles.container)}>
      {!hidden ? (
        <div className={classNames(styles.none)}>
          <div onClick={() => setHidden(true)}>
            <CMSSectionElement cmsItem={selectedCMSItem} />
          </div>
        </div>
      ) : (
        <div className={classNames(styles.border)}>
          <div className={styles.header}>
            <div>
              <Button
                text={"Done"}
                className={styles.btn}
                onClick={() => setHidden(false)}
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.cmsItemHeader}>CMS Item(s)</div>{" "}
            {/* <div>
              Icon Color: &nbsp;
              <Button
                text={"Light"}
                className={classNames(styles.btn, styles.styledBtn, {
                  [styles.selected]: light,
                })}
                onClick={() => setLight(true)}
              />{" "}
              <Button
                text={"Dark"}
                className={classNames(styles.btn, styles.styledBtn, {
                  [styles.selected]: !light,
                })}
                onClick={() => setLight(false)}
              />
            </div> */}
          </div>
          <div className={styles.search}>
            {selectedCMSItem.title && (
              <div className={styles.title}>
                {selectedCMSItem.title} ({selectedCMSItem.contentId})
              </div>
            )}
            <div className={styles.searchBar}>
              <SearchBar
                placeholderText="Search CMS"
                onInput={(value) => cmsItemSearch(value)}
              />
            </div>
            {cmsItemsToShow.map((cmsItem) => (
              // Update with key to prevent warnings (assuming contentId is unique)
              <div key={cmsItem.contentId} className={styles.searchResult}>
                <CMSSearchItem
                  cmsItem={cmsItem}
                  onAdd={(cmsItemToAdd) => addCmsItem(cmsItemToAdd)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

CMSDropdown.propTypes = {
  /**
   * CMS item content.
   */
  cmsItem: PropTypes.string,
  /**
   * Function that fires when a CMS item is selected.
   */
  setcmsItem: PropTypes.string,
};
